module.exports = __webpack_public_path__ + "img/answer-c1-1.bdac6582.png";